import React from 'react'
import { useViewport } from '../../utils'

const NavItem = ({text, icon, className, accent, uppercase, embed, small, isActive, onClick}) => {
  const accented = accent ? 'font-accent' : ''
  const uppercaseClass = uppercase ? 'uppercase' : ''

  const activeClassName = "border-b-2 lg:border-b-4 opacity-100"

  return (
    <div
      className={`cursor-pointer flex border-primary ${className} ${isActive ? activeClassName : 'opacity-50'}`}
      onClick={onClick}
    >
      {
        icon &&
        <div className="hidden lg:block mr-2">
          {icon}
        </div>
      }
      <p className={`font-bold text-center lg:text-left ${embed ? 'text-xs' : 'text-sm'} ${small ? 'lg:text-sm' : 'lg:text-base'} ${accented} ${uppercaseClass}`}>
        {text}
      </p>
    </div>
  )
}

const TableNav = ({links, activeTab, setActiveTab, className}) => {
  const { isDesktop } = useViewport()
  const fallbackClassName = 'mb-10'

  return isDesktop ? (
    <div className={`flex border-b ${className ? className : fallbackClassName}`}>
      {
        links.map((t, index) => {
          const className = index === 0 ? '' : 'ml-5'
          return <NavItem
            key={index}
            isActive={activeTab === t.value}
            text={t.label}
            className={`pb-4 ${className}`}
            small
            onClick={() => setActiveTab(t.value)}
          />
        })
      }
    </div>
  ) : (
    <div className={`flex border-b mb-8 w-full overflow-x-auto ${className}`}>
      {
        links.map((t, index) => {
          return <NavItem
            key={index}
            isActive={activeTab === t.value}
            text={t.label}
            className={`whitespace-no-wrap p-4`}
            embed
            onClick={() => setActiveTab(t.value)}
          />
        })
      }
    </div>
  )
}

export { TableNav }
